import { Link } from 'react-router';
import { useQuery } from '@tanstack/react-query';
import { api } from '../lib/api';
import { minutes } from '../lib/format';
import { ErrorNote, PageHeader, Spinner } from '../components/ui';

export default function RoutesPage() {
  const routes = useQuery({ queryKey: ['routes'], queryFn: api.routes });

  return (
    <>
      <PageHeader eyebrow="Hand-built" title="Routes">
        Tested loops and one-way runs with drive times between stops. Use one as-is or as a starting point for your own
        trip.
      </PageHeader>
      <div className="mx-auto max-w-7xl px-4 pb-14 sm:px-6">
        {routes.isLoading && <Spinner label="Loading routes" />}
        {routes.error && <ErrorNote error={routes.error} />}
        <div className="grid gap-4 md:grid-cols-2">
          {routes.data?.map((r) => (
            <Link
              key={r.slug}
              to={`/routes/${r.slug}`}
              className="card flex flex-col gap-2 p-6 text-cream no-underline hover:border-amber hover:text-cream"
            >
              <div className="flex justify-between gap-3">
                <span className="text-[13px] font-bold uppercase tracking-[0.1em] text-amber">{r.region}</span>
                {r.badge && <span className="chip">{r.badge}</span>}
              </div>
              <span className="font-display text-4xl font-black uppercase leading-none">{r.name}</span>
              <span className="text-muted">{r.towns.join(' · ')}</span>
              <span className="tabular-nums">
                {r.stopCount} stops · ~{r.estimatedMiles} mi · ~{minutes(r.estimatedMinutes)} driving{r.isLoop ? ' · loop' : ''}
              </span>
              {r.tip && <span className="text-sm text-dd">{r.tip}</span>}
            </Link>
          ))}
        </div>
      </div>
    </>
  );
}
